import { paymentOptions } from '../../const/paymentOptions';
import { isAutopayPaymentAmountOptionMutable, isMonthly, isPN4, isSecuredInstallmentLoanProduct } from '../../helpers';
import { deserializePaymentOption } from '../../helpers/generateAutopayPayload';
import isDCHCustomerAssistancePlanEnrolled from '../../helpers/isDCHCustomerAssistancePlanEnrolled';
import { t } from '../../strings/i18n';
import { required } from '../../xform';
export const PAYMENT_OPTION_INPUT_NAME = 'paymentOption';
const paymentOptionConfig = (apiMachineRef) => {
    var _a;
    const api = apiMachineRef.getSnapshot().context;
    const { featureFlags } = api;
    const accountSummary = api.accountSummaryQueryResult.data;
    const { billing } = accountSummary;
    const autopayStatus = api.autopayStatusQueryResult.data;
    const paymentEnterpriseEligibility = api.paymentEnterpriseEligibilityQueryResult.data;
    const productType = accountSummary.product.type;
    const isAutopayEnrolled = autopayStatus.enrollment;
    const mutable = isAutopayPaymentAmountOptionMutable(paymentEnterpriseEligibility, productType, featureFlags, billing)
        ? 'ENABLED'
        : 'DISABLED';
    let paymentOption;
    if (isAutopayEnrolled) {
        paymentOption = deserializePaymentOption((_a = autopayStatus === null || autopayStatus === void 0 ? void 0 : autopayStatus.enrollmentDetails) === null || _a === void 0 ? void 0 : _a.paymentOption, accountSummary);
    }
    else if (isMonthly(productType)) {
        paymentOption = paymentOptions.MONTHLY_FIXED_PAYMENT_AMOUNT;
    }
    else if (isPN4(productType)) {
        /*
         * An unenrolled PN4 account *shouldn't* exist, but perhaps it's possible
         * for someone to call in to cancel an autopay enrollment
         */
        paymentOption = paymentOptions.PN4_FIXED_PAYMENT_AMOUNT;
    }
    else if (isSecuredInstallmentLoanProduct(productType)) {
        paymentOption = paymentOptions.SECURED_INSTALLMENT_FIXED_PAYMENT_AMOUNT;
    }
    else if (isDCHCustomerAssistancePlanEnrolled(billing, productType, featureFlags)) {
        paymentOption = paymentOptions.NEW_MINIMUM_MONTHLY_DUE;
    }
    return [
        PAYMENT_OPTION_INPUT_NAME,
        paymentOption,
        mutable,
        [required(t('errors.paymentAmount'))]
    ];
};
export default paymentOptionConfig;
